import React from 'react';
import { Grid, MenuItem, TextField } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { FDataGrid } from '../grid';
import { ISimulationObjectiveRow, ISimulationTargetSetOption } from './simulation.models';

type Props = {
  rows: ISimulationObjectiveRow[];
  targetsetid?: number;
  targetsets: ISimulationTargetSetOption[];
  loading?: boolean;
  editable?: boolean;
  onTargetSetChange: (targetset: ISimulationTargetSetOption) => void;
};

class SimulationObjectiveImpactPanel extends React.PureComponent<Props> {
  columns: GridColDef[] = [
    { field: 'objectivecode', headerName: 'Objective', width: 140 },
    { field: 'objectivename', headerName: 'Name', flex: 1, minWidth: 250 },
    { field: 'priority', headerName: 'Priority', width: 115 },
    { field: 'weight', headerName: 'Weight', width: 100, type: 'number' },
    { field: 'targetvalue', headerName: 'Target', width: 135, type: 'number' },
    { field: 'actualvalue', headerName: 'Simulation', width: 135, type: 'number' },
    { field: 'gapvalue', headerName: 'Gap', width: 125, type: 'number' },
    { field: 'achievementrate', headerName: 'Achievement %', width: 140, type: 'number' },
    { field: 'status', headerName: 'Status', width: 125 },
    { field: 'recommendation', headerName: 'Recommended Action', flex: 1, minWidth: 250 },
  ];
  getRowId = (r: ISimulationObjectiveRow) => r.id || r.objectiveid || r.objectivecode;

  render() {
    return (
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 5 }}>
          <TextField select label="Governed Target Set" size="small" value={this.props.targetsetid || ''}
            disabled={this.props.loading || this.props.editable === false} fullWidth
            onChange={(e) => { const target = this.props.targetsets.find((x) => x.rid === Number(e.target.value)); if (target) this.props.onTargetSetChange(target); }}>
            {(this.props.targetsets || []).map((x) => <MenuItem key={x.rid} value={x.rid}>{x.code} — {x.name}</MenuItem>)}
          </TextField>
        </Grid>
        <Grid size={{ xs: 12 }}><FDataGrid title="Objective Impact" subtitle="Compare computed scenario outputs against the selected governed target set." rows={this.props.rows || []} columns={this.columns} loading={this.props.loading} height={540} showQuickFilter getRowId={this.getRowId} pageSizeOptions={[10, 25, 50]} /></Grid>
      </Grid>
    );
  }
}
export default SimulationObjectiveImpactPanel;
